"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLeafReducer = createLeafReducer;

var _createSliceHelper = require("./create-slice-helper");

var _deprecated = require("../deprecated.util");

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function createLeafReducer(parentSliceHelper, sliceName, initialSlice) {
  var sliceHelper = (0, _createSliceHelper.createSliceHelper)(parentSliceHelper, sliceName, initialSlice);
  var actionReducerMap = {};

  var addActionReducerMap = function addActionReducerMap(newActionReducerMap) {
    actionReducerMap = _objectSpread({}, actionReducerMap, newActionReducerMap);
  };

  var addHandlers = function addHandlers(newActionReducerMap) {
    (0, _deprecated.deprecated)('addHandlers() is deprecated, use addActionReducerMap()');
    addActionReducerMap(newActionReducerMap);
  };

  var reducer = function reducer() {
    var slice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialSlice;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    if (action.type in actionReducerMap) {
      return actionReducerMap[action.type](slice, action);
    }

    return slice;
  };

  return Object.assign(reducer, _objectSpread({
    addActionReducerMap: addActionReducerMap,
    addHandlers: addHandlers
  }, sliceHelper));
}